import React from 'react';
import { TipsMapType } from '../index';

export const steamPerformanceTaggedStarTips: TipsMapType = {
  en: (
    <>
      Star tagged reviews on Steam will be counted in the overall review score,
      as the user directly purchased the game on steam or obtained a free
      license for the game.
      <br />
      DataBrain started crawling Starred tag from May 2024.
    </>
  ),
  zh: (
    <>
      steam内星标评论将会计入总评测分数，因为该用户直接在 Steam
      上购买了游戏或是获得了免费游戏的免费许可。
      <br />
      DataBrain 于 2024 年 5 月开始采集 Starred 数据。
    </>
  ),
};

export const steamPerformanceStarTaggedTipsInfo: TipsMapType = {
  en: 'DataBrain started crawling Starred tag from May 2024.',
  zh: 'DataBrain 于 2024 年 5 月开始采集 Starred 数据。',
};

export const steamPerformanceReceivedForFreeTips: TipsMapType = {
  en: 'Number of reviews received the game for free on Steam',
  zh: 'steam内免费体验游戏的评论数',
};

export const steamPerformanceRefundGameTips: TipsMapType = {
  en: 'Number of reviews from users who refunded the game on Steam',
  zh: 'steam内存在退款行为的评论数',
};

export const steamPerformanceOnRecordTimeTips: TipsMapType = {
  en: 'Total on-record playtime of the reviewer on Steam',
  zh: 'steam内评论账号的总游玩时长',
};

export const steamPerformanceOnReviewTimeTips: TipsMapType = {
  en: 'Playtime of reviewers on Steam at the time of their review',
  zh: 'steam内账号在评论时的游玩时长',
};

export const steamPerformanceFilteredReviewsTips: TipsMapType = {
  en: 'Total newly added reviews after filtering.',
  zh: '统计符合筛选条件下的所有Steam新增评论。',
};

export const steamPerformanceAllReviewsTips: TipsMapType = {
  en: 'Only count the Steam reviews that are marked with a star. A starred review indicates that the reviewer activated the game via a Steam key, received it as a gift, or obtained it via a temporary free license.',
  zh: '仅统计带了星标的Steam评论，评论有星标说明评论者通过购买、被赠送或临时免费许可证获得的游戏。',
};

export const steamPerformanceRealtimeAccumulatedSteamReviewsTips: TipsMapType =
{
  en: (
    <>
      All Reviews and Recent Reviews are scraped from the Steam platform page
      and represent cumulative values as calculated by Steam.
      <br />
      Due to Steam's statistical data's update frequency, the "Hourly New
      Reviews" data displayed below may be inconsistent.
      <br /> <br />
      Note: Steam updates the above ratings data once every hour.
    </>
  ),
  zh: (
    <>
      【全部评论】、【近期评论】从Steam平台页面上爬取，为Steam统计的累计值；
      <br />
      受限于Steam平台自身的统计数据更新频率，可能与下方的“小时新增评论”数据不一致。{' '}
      <br /> <br />
      注：Steam平台针对以上评分数据每一小时刷新一次统计
    </>
  ),
};

export const steamPerformanceHourlyAddedReviewsTips: TipsMapType = {
  en: (
    <>
      Based on the specific reviews scraped from the Steam platform, calculate
      the total newly added reviews after filtering.
      <br /> <br />
      Note: Steam updates the players' reviews every 10 to 20 minutes.
    </>
  ),
  zh: (
    <>
      基于从Steam平台爬取到的具体评论，统计符合筛选条件下的所有Steam新增评论。
      <br /> <br />
      注：Steam平台上的评论每10~20分钟刷新一次
    </>
  ),
};

export const steamPerformanceSupportLanguageTips: TipsMapType = {
  en: (
    <>
      The data is sourced from All Reviews ratings across different language
      versions of this game on the Steam platform.
    </>
  ),
  zh: <>数据来源于Steam官网本游戏各语言下对应的全部评论评分。</>,
};

export const steamPerformanceMetaStoreTips: TipsMapType = {
  en: 'Data from Meta platform',
  zh: '数据来源: Meta 平台',
};